/**
 * AssignmentProvider запросы связанные с выдачей заданий
 */
import {
    IAssignmentPeriodsResponse,
    IGetAssignmentPeriodsProps,
    IGetNextOnlineLessonsProps,
    IGetNextOnlineLessonsResponse,
} from '@fsd-shared/models/assignment';
import { postApiRequest } from 'api';

const AssignmentProvider = {
    /**
     * @description Получение доступного периода для выдачи задания
     * @param params
     */
    getAssignmentPeriods: (params?: IGetAssignmentPeriodsProps): Promise<IAssignmentPeriodsResponse> => {
        return postApiRequest(`api/v2/course-group/assignment-period/`, params);
    },
    getNextOnlineLessons: (params?: IGetNextOnlineLessonsProps): Promise<IGetNextOnlineLessonsResponse> => {
        return postApiRequest(`api/v2/course-group/next-online-lessons/`, params);
    },
};

export { AssignmentProvider };
